import { createAction, props } from '@ngrx/store';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { InvitationData } from 'src/app/model/api/invitation-data';
import { PaginationParams } from 'src/app/model/api/pagination-params';

import { Headquarter } from 'src/app/model/headquarter';
import { Lang } from 'src/app/model/lang';
import { NotificationMaintenance } from 'src/app/model/notification-maintenance';
import { ReleaseNote } from 'src/app/model/release-note';
import { User } from 'src/app/model/user';

export const unmuteWebsocket = createAction('UNMUTE_WEBSOCKET');
export const muteWebsocket = createAction('MUTE_WEBSOCKET');

export const getCurrentUser = createAction('GET_CURRENT_USER', props<{ redirect: boolean }>());
export const getCurrentUserSuccess = createAction('GET_CURRENT_USER_SUCCESS', props<{
    currentUser: User; currentTechnician?: User; redirect: boolean; redirectImpers?: boolean;
}>());
export const getCurrentUserFailed = createAction('GET_CURRENT_USER_FAILED', props<{ errorMessage: string }>());

export const setCurrentLang = createAction('SET_CURRENT_LANG', props<{ lang: Lang }>());
export const setCurrentLangSuccess = createAction('SET_CURRENT_LANG_SUCCESS', props<{ lang: Lang }>());

export const updateCurrentUser = createAction('UPDATE_CURRENT_USER', props<{ user: User }>());
export const updateCurrentUserSuccess = createAction('UPDATE_CURRENT_USER_SUCCESS', props<{ message: string; redirect: boolean }>());
export const updateCurrentUserFailed = createAction('UPDATE_CURRENT_USER_FAILED', props<{ errorMessage: string }>());

export const updateCurrentUserExitBeta = createAction('UPDATE_CURRENT_USER_EXIT_BETA', props<{ user: User }>());
export const updateCurrentUserExitBetaSuccess = createAction('UPDATE_CURRENT_USER_EXIT_BETA_SUCCESS', props<{ message: string; redirect: boolean }>());
export const updateCurrentUserExitBetaFailed = createAction('UPDATE_CURRENT_USER_EXIT_BETA_FAILED', props<{ errorMessage: string }>());

export const getHeadQuarters = createAction('GET_HEADQUARTERS');
export const getHeadQuartersSuccess = createAction('GET_HEADQUARTERS_SUCCESS', props<{ headquarters: Headquarter[] }>());
export const getHeadQuartersFailed = createAction('GET_HEADQUARTERS_FAILED', props<{ errorMessage: string }>());

export const confirmShareDevice = createAction('CONFIRM_SHARE_DEVICE', props<{ invitationData: InvitationData }>());
export const confirmShareDeviceSuccess = createAction('CONFIRM_SHARE_DEVICE_SUCCESS', props<{ message: string }>());
export const confirmShareDeviceFailed = createAction('CONFIRM_SHARE_DEVICE_FAILED', props<{ errorMessage: string }>());

export const confirmSiteTransfer = createAction('CONFIRM_USER_SITE_TRANSFER', props<{
    siteId: number; ownerId: number; verification: string; userId?: number;
}>());
export const confirmSiteTransferSuccess = createAction('CONFIRM_USER_SITE_TRANSFER_SUCCESS');
export const confirmSiteTransferFailed = createAction('CONFIRM_USER_SITE_TRANSFER_FAILED', props<{ errorMessage: string }>());

export const getTechnicians = createAction('GET_TECHNICIANS');
export const getTechniciansSuccess = createAction('GET_TECHNICIANS_SUCCESS', props<{ technicians: User[] }>());
export const getTechniciansFailed = createAction('GET_TECHNICIANS_FAILED', props<{ errorMessage: string }>());

export const assignTechnicianToUser = createAction('ASSIGN_TECHNICIAN_TO_USER', props<{
    techCode?: string; userId?: number; technicianId?: number; verification?: string;
}>());
export const assignTechnicianToUserSuccess = createAction('ASSIGN_TECHNICIAN_TO_USER_SUCCESS', props<{ message: string }>());
export const assignTechnicianToUserFailed = createAction('ASSIGN_TECHNICIAN_TO_USER_FAILED', props<{ errorMessage: string }>());

export const unassignTechnicianToUser = createAction('UNASSIGN_TECHNICIAN_TO_USER', props<{ id: number }>());
export const unassignTechnicianToUserSuccess = createAction('UNASSIGN_TECHNICIAN_TO_USER_SUCCESS', props<{
    message: string; id: number;
}>());
export const unassignTechnicianToUserFailed = createAction('UNASSIGN_TECHNICIAN_TO_USER_FAILED', props<{ errorMessage: string }>());

export const resetSearchFailedTechnicianByCode = createAction('RESET_SEARCH_FAILED_GET_TECHNICIAN_CODE');
export const getTechnicianByCode = createAction('GET_TECHNICIAN_BY_CODE', props<{ code: string }>());
export const getTechnicianSuccess = createAction('GET_TECHNICIAN_SUCCESS', props<{ technician: User }>());
export const getTechnicianFailed = createAction('GET_TECHNICIAN_FAILED', props<{ errorMessage: string }>());

export const revokeShareInvitationReset = createAction('REVOKE_SHARE_INVITATION_RESET');
export const revokeShareInvitation = createAction('REVOKE_SHARE_INVITATION', props<{ deviceId?: number; email: string }>());
export const revokeShareInvitationSuccess = createAction('REVOKE_SHARE_INVITATION_SUCCESS', props<{ email: string; message: string }>());
export const revokeShareInvitationFailed = createAction('REVOKE_SHARE_INVITATION_FAILED', props<{ errorMessage: string }>());

export const getCustomers = createAction('GET_CUSTOMERS', props<{ paging?: PaginationParams; filter?: string; status?: string }>());
export const getCustomersSuccess = createAction('GET_CUSTOMERS_SUCCESS', props<{ paging: ItemsPagination; customers: User[] }>());
export const getCustomersFailed = createAction('GET_CUSTOMERS_FAILED', props<{ errorMessage: string }>());

export const getAllCustomers = createAction('GET_ALL_CUSTOMERS');
export const getAllCustomersSuccess = createAction('GET_ALL_CUSTOMERS_SUCCESS', props<{ customers: User[] }>());
export const getAllCustomersFailed = createAction('GET_ALL_CUSTOMERS_FAILED', props<{ errorMessage: string }>());

export const resetCustomerDialog = createAction('RESET_CUSTOMER_DIALOG');
export const inviteCustomer = createAction('INVITE_CUSTOMER', props<{ email: string; firstName: string; lastName: string }>());
export const inviteCustomerSuccess = createAction('INVITE_CUSTOMER_SUCCESS', props<{ message: string }>());
export const inviteCustomerFailed = createAction('INVITE_CUSTOMER_FAILED', props<{ errorMessage: string }>());

export const revokeCustomerInvitation = createAction('REVOKE_CUSTOMER_INVITATION', props<{ email: string }>());
export const revokeCustomerInvitationSuccess = createAction('REVOKE_CUSTOMER_INVITATION_SUCCESS', props<{
    email: string; message: string;
}>());
export const revokeCustomerInvitationFailed = createAction('REVOKE_CUSTOMER_INVITATION_FAILED', props<{ errorMessage: string }>());

export const deleteCustomer = createAction('DELETE_CUSTOMER', props<{ userId: number }>());
export const deleteCustomerSuccess = createAction('DELETE_CUSTOMER_SUCCESS', props<{ userId: number; message: string }>());
export const deleteCustomerFailed = createAction('DELETE_CUSTOMER_FAILED', props<{ errorMessage: string }>());

export const setDraftMode = createAction('SET_DRAFT_MODE');
export const unsetDraftMode = createAction('UNSET_DRAFT_MODE');

export const readyToSetImpersonation = createAction('READY_TO_SET_IMPERSONATION');
export const endToSetImpersonation = createAction('END_TO_SET_IMPERSONATION');
export const setImpersonation = createAction('SET_IMPERSONATION', props<{ user?: User; userId?: number; siteId?: number }>());
export const unsetImpersonation = createAction('UNSET_IMPERSONATION');

// export const closeAccountReset = createAction('CLOSE_ACCOUNT_RESET');
export const closeAccount = createAction('CLOSE_ACCOUNT', props<{ pwd: string, countryName: string; iAmTechnician: boolean, lang: Lang }>());
export const closeAccountSuccess = createAction('CLOSE_ACCOUNT_SUCCESS', props<{ message: string }>());
export const closeAccountFailed = createAction('CLOSE_ACCOUNT_FAILED', props<{ errorMessage: string }>());

// eslint-disable-next-line max-len
export const getNotificationMaintenance = createAction('GET_NOTIFICATION_MAINTENANCE_MAINTENANCE');
// eslint-disable-next-line max-len
export const getNotificationMaintenanceSuccess = createAction('GET_NOTIFICATION_MAINTENANCE_SUCCESS', props<{ notificationMaintenance: NotificationMaintenance[] }>());
export const getNotificationMaintenanceFailed = createAction('GET_NOTIFICATION_MAINTENANCE_FAILED', props<{ errorMessage: string }>());

export const setFePrecLogin = createAction('SET_FE_PREC_LOGIN', props<{ userId: number }>());
export const setFePrecLoginSuccess = createAction('SET_FE_PREC_LOGIN_SUCCESS');
export const setFePrecLoginFailed = createAction('SET_FE_PREC_LOGIN_FAILED', props<{ errorMessage: string }>());



export const getReleaseNoteList = createAction('GET_RELEASE_NOTE_LIST', props<{ size?: number }>());
export const getReleaseNoteListSuccess = createAction('GET_RELEASE_NOTE_LIST_SUCCESS', props<{ releaseNoteList: ReleaseNote[] }>());
export const getReleaseNoteListFailed = createAction('GET_RELEASE_NOTE_LIST_FAILED', props<{ errorMessage: string }>());
export const getPrivacyNoteList = createAction('GET_PRIVACY_NOTE_LIST', props<{ size?: number }>());
export const getPrivacyNoteListSuccess = createAction('GET_PRIVACY_NOTE_LIST_SUCCESS', props<{ privacyNoteList: ReleaseNote[] }>());
export const getPrivacyNoteListFailed = createAction('GET_PRIVACY_NOTE_LIST_FAILED', props<{ errorMessage: string }>());



export const setFeReleaseVersion = createAction('SET_FE_RELEASE_VERSION', props<{ version: string }>());
export const setFeReleaseVersionSuccess = createAction('SET_FE_RELEASE_VERSION_SUCCESS', props<{ version: string }>());
export const setFeReleaseVersionFailed = createAction('SET_FE_RELEASE_VERSION_FAILED', props<{ errorMessage: string }>());

export const setFePrivacyVersion = createAction('SET_FE_PRIVACY_VERSION', props<{ version: string }>());
export const setFePrivacyVersionSuccess = createAction('SET_FE_PRIVACY_VERSION_SUCCESS', props<{ version: string }>());
export const setFePrivacyVersionFailed = createAction('SET_FE_PRIVACY_VERSION_FAILED', props<{ errorMessage: string }>());

export const setRatingVote = createAction('SET_RATING_VOTE', props<{ ratingValue: number, text: string, appVersion: string }>());
export const setRatingVoteSuccess = createAction('SET_RATING_VOTE_SUCCESS', props<{ ratingId: number, message: string }>());
export const setRatingVoteFailed = createAction('SET_RATING_VOTE_FAILED', props<{ errorMessage: string }>());

export const getNextRatingVote = createAction('GET_NEXT_RATING_VOTE');
export const getNextRatingVoteSuccess = createAction('GET_NEXT_RATING_VOTE_SUCCESS', props<{ askNextRatingDate: string }>());
export const getNextRatingVoteFailed = createAction('GET_NEXT_RATING_VOTE_FAILED', props<{ errorMessage: string }>());